var crSavePickupProperties = true;
var CRskipUpdateFormAction = true;
//var crBeacon = true; // disabled on Sep 6th as it might the one causing the missing information
if (typeof stores !== 'undefined') {
  for (var i = 0; i < stores.length; i++) {
        if (!stores[i]) continue;

        var storeName = stores[i].name.toLowerCase();
        var storeId = stores[i].storeID;

    //Metairie+Gretna exclude Belle Chasse   
    if (specialProduct4 === true) {
          if (storeId === 7799  ) {
            delete stores[i];
          }         
    } else
      
      // Metairie+Belle Chasse exclude Gretna
    if (specialProduct5 === true) {
          if (storeId === 8239 ) {
            delete stores[i];
          }         
    } else 
    //Belle Chasse+Gretna exclude Metairie
    if (specialProduct6 === true) {
          if (storeId === 2800) {
            delete stores[i];
          }         
    } else 
      
        if (specialProduct === true) {
          if (storeId === 2800  || storeId === 8239 || storeId === 3762 ) {
            delete stores[i];
          }         
        } else

        if (specialProduct2 === true) {
          if (storeId === 2800  || storeId === 7799 || storeId === 3762  ) {
            delete stores[i];
          }         
        } else

       if (specialProduct3 === true) {
          if (storeId === 8239   || storeId === 7799 || storeId === 3762  ) {
            delete stores[i];
          }         
        }

        if (specialProduct7 === true) {
          if (storeId === 8239   || storeId === 7799 || storeId === 2800 ) {
            delete stores[i];
          }         
        }

  }
}
document.addEventListener('crPickupActivated', function (e) { 
  console.log('*** Activated ***');

  if (
    (specialProduct === true && specialProduct2 === true) ||
    (specialProduct === true && specialProduct3 === true) ||
    (specialProduct === true && specialProduct4 === true) ||
    (specialProduct === true && specialProduct5 === true) ||
    (specialProduct === true && specialProduct6 === true) ||
    (specialProduct === true && specialProduct7 === true) ||
    
    (specialProduct2 === true && specialProduct3 === true) ||
    (specialProduct2 === true && specialProduct4 === true) ||
    (specialProduct2 === true && specialProduct5 === true) ||
    (specialProduct2 === true && specialProduct6 === true) ||
    (specialProduct2 === true && specialProduct7 === true) ||
    
    (specialProduct3 === true && specialProduct4 === true) ||
    (specialProduct3 === true && specialProduct5 === true) ||
    (specialProduct3 === true && specialProduct6 === true) ||
    (specialProduct3 === true && specialProduct7 === true) ||
    
    (specialProduct4 === true && specialProduct5 === true) ||
    (specialProduct4 === true && specialProduct6 === true) ||
    (specialProduct4 === true && specialProduct7 === true) ||
    
    (specialProduct5 === true && specialProduct6 === true) ||
    (specialProduct5 === true && specialProduct7 === true) ||
    
    (specialProduct6 === true && specialProduct7 === true) 
   ) {
    console.log('disable');
    disableCheckoutButton();
  	var tt = setInterval(function(){disableCheckoutButton();}, 1000);
	setTimeout(function() { clearInterval(tt); }, 7000);  
	jqCR('#cr-error').html('Your order contains products from multiple locations, for that reason you can not choose this option.')
    jqCR('#pickup-details').remove()
    }
});




function activateCheckoutButton(){
    document.querySelector('[name=checkout]').disabled = false;
  }

function disableCheckoutButton(){    
    document.querySelector('[name=checkout]').disabled = true;
}
